<script setup>
import { ref, watch, onMounted } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { Slide } from "vue3-burger-menu";
import HeaderSection from "./components/HeaderSection.vue";
import FooterSection from "./components/FooterSection.vue";

const showMenu = ref(false);

// 1. Destructure isLoading alongside isAuthenticated & logout
const { logout, isAuthenticated, isLoading } = useAuth0();

const initialize = () => {
  showMenu.value = isAuthenticated.value;
};

onMounted(() => {
  initialize();
});

const handleLogout = () => {
  logout({ logoutParams: { returnTo: window.location.origin } });
};

// 2. Separated watch block for isAuthenticated
watch(
  () => isAuthenticated.value,
  (status) => {
    showMenu.value = status;
  },
  { immediate: true }
);

// If you have a prop for userLocation (e.g., defineProps), watch it separately:
/* 
const props = defineProps(['userLocation']);

watch(
  () => props.userLocation,
  (newLoc) => {
    if (newLoc) {
      fetchUKWeather();
    }
  },
  { immediate: true }
);
*/
</script>

<template>
  <!-- 3. Show a loader while Auth0 determines authentication status -->
  <div v-if="isLoading" class="app-loading">
    <p>Loading...</p>
  </div>

  <!-- 4. Main App layout renders only once Auth0 is ready -->
  <div v-else id="app">
    <Slide no-overlay :burger-icon="showMenu">
      <img src="../src/assets/images/blything-mobile-menu-logo.png" />
      <router-link id="home" to="/">
        <font-awesome-icon :icon="['fas', 'house']" /><span>Home</span>
      </router-link>
      <router-link id="profile" to="/profile">
        <font-awesome-icon :icon="['fas', 'user']" /><span>Profile</span>
      </router-link>
      <a id="logout" @click="handleLogout">
        <font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" /><span>Logout</span>
      </a>
    </Slide>

    <div id="page-stretch">
      <div id="header">
        <HeaderSection />
      </div>

      <div id="page-content" class="grid-x grid-padding-x">
        <router-view />
      </div>
    </div>

    <div id="footer" class="footer">
      <FooterSection />
    </div>
  </div>
</template>

<style lang="scss">
@use "./assets/styles/variables.scss" as *;
@use "./assets/styles/main.scss";

.app-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  p {
    color: $dark-pink;
    font-size: 7cqmin;
  }

}
</style>